<template>
  <HKLModal
    ref="modal"
    okBtnAction="send"
    :beforeOkClick="validateFields"
    @onOkClick="sendReminder"
    @onCloseClick="cleanModalState"
  >
    <template slot="title">
      <span :class="{ 'required-flag': true }">{{ $t('tenantProjects.finalDocuments.sendReminder.hint') }}</span>
      <label>{{ $t('hint.continue') }}</label>
    </template>
    <TextField
      class="check-valid"
      :value="sendReminderComment"
      :required="true"
      :placeholder="$t('tenantProjects.finalDocuments.sendReminder.placeHolder')"
      @updateValue="val => sendReminderComment = val"
    />
  </HKLModal>
</template>

<script>
import lodash from 'lodash'
import { ref, unref } from '@vue/composition-api'
import HKLModal from '@/controls/Modal/HKLModal'
import TextField from '@/controls/TextField'
import { utils as formUtils } from '@/plugin/InputChange'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useStoreActions, useStoreGetters } from '@/store'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { buildReminderData } from '@/api/postman/tenantProject'
import * as tenantProjectApi from '@/api/tenantProjects/request'

export default {
  components: {
    HKLModal,
    TextField,
  },
  setup () {
    const { currentTenantProject, finalDocument } = useStoreGetters('tenantProject', ['currentTenantProject', 'finalDocument'])
    const { loadFinalDocumentHistories } = useStoreActions('tenantProject', ['loadFinalDocumentHistories'])

    const sendReminderComment = ref('')
    const modals = useRefModal()
    const validateFields = () => {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.check-valid')
      return fusionInputCheckUtil.isAllFieldsValid('.check-valid')
    }
    const cleanModalState = () => {
      sendReminderComment.value = ''
      formUtils.resetDirty()
    }
    const sendReminder = async () => {
      try {
        const currentTP = unref(currentTenantProject)
        const finalDocs = unref(finalDocument)
        const extraMetaData = {
          comments: unref(sendReminderComment),
          key: finalDocs.id,
          tenancyType: lodash.get(currentTP, 'tenancy.type'),
          buildingId: lodash.get(currentTP, 'tenancy.buildingId'),
        }
        const { basicMetaData, toEmails } = await buildReminderData()
        const metaData = {...basicMetaData, ...extraMetaData}
        const requestBody = {metaData, toEmails}
        await tenantProjectApi.sendFinalReminder(finalDocs.id, requestBody)
        loadFinalDocumentHistories()
        sendReminderComment.value = ''
      } finally {
        formUtils.resetDirty()
      }
    }

    return {
      validateFields,
      sendReminder,
      sendReminderComment,
      cleanModalState,
      ...modals,
      currentTenantProject,

    }
  },
}

</script>
